module.exports = __webpack_public_path__ + "svg_80x80/dotnetfx.98cf61.svg";